/**
 * @author Marco Visin
 * @date 2025-05-30
 */

import { INodeProperties } from 'n8n-workflow';

export const noteOperations: INodeProperties[] = [
	{
		displayName: 'Operation',
		name: 'operation',
		type: 'options',
		noDataExpression: true,
		displayOptions: {
			show: {
				resource: ['note'],
			},
		},
		options: [
			{
				name: 'Create',
				value: 'create',
				description: 'Create a new note',
				action: 'Create a note',
			},
			{
				name: 'Get',
				value: 'get',
				description: 'Get notes by external ID',
				action: 'Get notes',
			},
		],
		default: 'create',
	},
];

export const noteFields: INodeProperties[] = [
	// Create fields
	{
		displayName: 'External ID',
		name: 'ext_id',
		type: 'string',
		required: true,
		displayOptions: {
			show: {
				resource: ['note'],
				operation: ['create', 'get'],
			},
		},
		default: '',
		description: 'The external ID (e.g., contact ID) to associate the note with',
	},
	{
		displayName: 'Note Text',
		name: 'text',
		type: 'string',
		typeOptions: {
			rows: 4,
		},
		required: true,
		displayOptions: {
			show: {
				resource: ['note'],
				operation: ['create'],
			},
		},
		default: '',
		description: 'The content of the note',
	},
	{
		displayName: 'External Table Name',
		name: 'ext_table_name',
		type: 'options',
		options: [
			{
				name: 'Contacts',
				value: 'contacts',
			},
			{
				name: 'Jobs',
				value: 'jobs',
			},
		],
		displayOptions: {
			show: {
				resource: ['note'],
				operation: ['create'],
			},
		},
		default: 'contacts',
		description: 'The table name the note is associated with',
	},
	{
		displayName: 'Visibility',
		name: 'visibility',
		type: 'options',
		options: [
			{
				name: 'Private',
				value: 'private',
			},
			{
				name: 'Public',
				value: 'public',
			},
		],
		displayOptions: {
			show: {
				resource: ['note'],
				operation: ['create'],
			},
		},
		default: 'private',
		description: 'The visibility of the note',
	},
	{
		displayName: 'Flag Color',
		name: 'flagColor',
		type: 'string',
		displayOptions: {
			show: {
				resource: ['note'],
				operation: ['create'],
			},
		},
		default: '',
		description: 'Optional color flag for the note (e.g., #ff0000)',
	},
];
